import React, { useState, useContext } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import _ from "lodash";
import { ModalContext } from "App";
import PinInput from "modules/common/components/PinInput";
import CountdownComponent from "modules/common/components/CountdownComponent";
import FormInputMobile from "modules/common/components/FormInputMobile";
import CmsContext from "../../../../../CmsContext";
import * as actions from "../../../actions";
import * as c from "../../../constants";

function MultiFactorAuthenticationSms({
  email2fa,
  goBack,
  history,
  resendMfaOtp,
  isLoading,
  resending,
  mfaLogin,
  profile,
  savePreferredLogin,
  selectedMfa,
  temporaryToken,
  getProfileInfo,
  onCountdown,
  isResendTimerOTP,
  cooldownTime,
}) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  const CMS_LOGOS = cmsContext.findByType("LOGOS");
  const [showOTP, setShowOTP] = useState(false);
  const [rand, setRand] = useState(_.random(1, 1000));
  const [formData, setFormData] = useState({
    mobile_number: _.get(profile, "mobile_number"),
  });

  const handleGoBack = (e) => {
    e.preventDefault();
    goBack(0);
  };

  const handleGoBackConfirmation = (e) => {
    e.preventDefault();
    setShowOTP(false);
  };

  const handleOnChange = (e) => {
    e.preventDefault();
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleOnchangePin = (otp) => {
    setFormData({
      ...formData,
      otp,
    });
  };

  const secretSms = (val) => {
    return [...val].map((item, i) => (i > 1 && i < 9 ? "*" : item));
  };

  const handleNext = () => {
    const args = {
      receiver_type: "sms",
      token: temporaryToken,
    };

    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: "submit" }).then((captcha_token) => {
        if (!isResendTimerOTP) {
          return email2fa({ ...args, recaptcha: captcha_token }, () => {
            setShowOTP(true);
            onCountdown();
          });
        }
        return setShowOTP(true);
      });
    });
  };

  const handleSubmitOTP = (e) => {
    e.preventDefault();

    const args = {
      secret: formData.otp,
      mfa_type: "sms_otp",
      token: temporaryToken,
    };

    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: "submit" }).then((captcha_token) => {
        mfaLogin({ ...args, recaptcha: captcha_token }, () => {
          const token = localStorage.getItem("token");
          if (selectedMfa === 1) {
            const mfaArgs = {
              token,
              preferred_mfa: "sms_otp",
            };

            savePreferredLogin(mfaArgs, () => {
              getProfileInfo();
            });
          }
          setModal({ isOpen: false });
          history.push("/");
        });
      });
    });
  };

  const handleResendMfaOtp = (e) => {
    e.preventDefault();

    const args = {
      receiver_type: "sms",
      token: temporaryToken,
    };

    window.grecaptcha.enterprise.ready(() => {
      window.grecaptcha.enterprise.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: "submit" }).then((captcha_token) => {
        if (!isResendTimerOTP) {
          return resendMfaOtp({ ...args, recaptcha: captcha_token }, () => {
            setRand(_.random(1, 1000));
            setShowOTP(true);
            onCountdown();
          });
        }
        return setShowOTP(true);
      });
    });
  };
  
  return (
    <>
      {!showOTP && (
        <>
          <div>
            <button onClick={handleGoBack} type="button" className="mfa-back-button cms-text-primary my-2">
              <i className="fas fa-chevron-left mfa-back-login" /> Back
            </button>
          </div>
          <div className="mfa-modal">
            <img src={_.get(CMS_LOGOS, "MAIN_LOGO.cdnUrl")} alt="" className="icon-logo mb-3" />
            <h2 className="mb-3 mt-6 font-weight-bold cms-text-primary">Multi-Factor Authentication</h2>
            <div className="mfa-setup-description text-left">
              {profile.is_sms_2fa_enabled === true
                ? "To continue your login to your account"
                : "To continue setting up SMS Authentication for your account"}
              , please confirm your mobile number below:
            </div>
            <div className="form-wrapper">
              <div className="full-group">
                <div className="form-row">
                  <div className="form-input-group col-12 mt-2">
                    <label htmlFor="mobile_number" className="full-label mb-0 login-options">
                      Mobile Number
                    </label>
                    <FormInputMobile
                      disableDropdown={false}
                      autoComplete="off"
                      type="tel"
                      disabled
                      name="mobile_number"
                      onChange={handleOnChange}
                      value={_.get(formData, "mobile_number") || ""}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                onClick={handleNext}
                disabled={!_.get(formData, "mobile_number") || isResendTimerOTP}
                className="mt-3 btn btn-primary btn-block cms-bg-color-primary cms-outline-primary"
              >
                <span className="font-weight-bold text-nowrap">Continue {cooldownTime > 0 && `(0:${cooldownTime.toString().padStart(2, "0")})`}</span>
              </button>
            </div>
          </div>
        </>
      )}
      {showOTP && (
        <>
          <div>
            <button onClick={handleGoBackConfirmation} type="button" className="mfa-back-button cms-text-primary my-2">
              <i className="fas fa-chevron-left mfa-back-login" /> Back
            </button>
          </div>
          <form className="mfa-modal" onSubmit={handleSubmitOTP}>
            <img src={_.get(CMS_LOGOS, "MAIN_LOGO.cdnUrl")} alt="" className="icon-logo" />
            <div className="form-header p-3 mt-2 cms-bg-color-primary-ligt mfa-description">
              We sent your One Time Password (OTP) to{" "}
              <span className="text-success">
                {_.get(formData, "mobile_number") ? secretSms(_.get(formData, "mobile_number")) : secretSms(_.get(formData, "mobile_number"))}
              </span>
              {!profile.is_sms_2fa_enabled && (
                <div className="mt-2">
                  This will be used to set up <b> SMS Authentication </b> in your account.
                </div>
              )}
            </div>
            <div className="col-12 mt-2">
              <PinInput onChange={handleOnchangePin} />
            </div>
            <div className="col-12 mt-2 text-center">
              <CountdownComponent key={`countdown-${rand}`} />
            </div>
            <div className="d-flex flex-column flex-md-row flex-lg-row flex-xl-row text-center">
              <div className="col-12 col-md-6">
                <button
                  onClick={handleResendMfaOtp}
                  type="submit"
                  className="btn btn-outline-primary mt-4 btn-block cms-text-primary cms-outline-primary"
                  disabled={isResendTimerOTP}
                >
                  {resending && <i className="fa fa-spin fa-spinner" />}
                  <span className="mr-2 label-small text-nowrap">Resend OTP {cooldownTime > 0 && `(0:${cooldownTime.toString().padStart(2, "0")})`}</span>
                </button>
              </div>
              <div className="col-12 col-md-6">
                <button type="submit" className="btn btn-primary mt-4 btn-block cms-bg-color-primary" disabled={isLoading || _.isEmpty(formData.otp)}>
                  {isLoading && <i className="fa fa-spin fa-spinner" />}
                  Submit
                </button>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col d-flex align-items-center justify-content-center">
                <button type="button" onClick={handleGoBack} className="btn btn-change cms-text-primary">
                  <span className="font-weight-bold">Change Authentication Method</span>
                </button>
              </div>
            </div>
          </form>
        </>
      )}
    </>
  );
}

MultiFactorAuthenticationSms.propTypes = {
  goBack: PropTypes.instanceOf(Function).isRequired,
  email2fa: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  resendMfaOtp: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  resending: PropTypes.bool.isRequired,
  mfaLogin: PropTypes.instanceOf(Function).isRequired,
  profile: PropTypes.instanceOf(Object).isRequired,
  savePreferredLogin: PropTypes.instanceOf(Function).isRequired,
  selectedMfa: PropTypes.number.isRequired,
  temporaryToken: PropTypes.string.isRequired,
  getProfileInfo: PropTypes.instanceOf(Function).isRequired,
  onCountdown: PropTypes.instanceOf(Function).isRequired,
  isResendTimerOTP: PropTypes.bool.isRequired,
  cooldownTime: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }) => ({
  temporaryToken: sessionStorage.getItem("temporaryToken") || "",
  isLoading: _.get(api, "loading", []).indexOf(c.ENABLE_2FA) > -1,
  resending: _.get(api, "loading", []).indexOf(c.RESEND_OTP) > -1,
});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
    getProfileInfo: actions.getProfile,
  }),
]);

export default enhance(MultiFactorAuthenticationSms);
